import { FC } from "react";

import {
  ChevronDownIcon,
  Select,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicator,
  SelectDragIndicatorWrapper,
  SelectIcon,
  SelectInput,
  SelectItem,
  SelectPortal,
  SelectTrigger,
} from "../base";

interface DropdownPickerItem {
  isDisabled?: boolean;
  label: string;
  value: string;
}

interface DropdownPickerProps {
  className?: string;
  isDisabled?: boolean;
  items: DropdownPickerItem[];
  onChange: (value: string) => void;
  placeholder: string;
  selectKey?: string;
  size?: "sm" | "md" | "lg" | "xl";
  value: string | null;
}

const DropdownPicker: FC<DropdownPickerProps> = ({
  className,
  isDisabled = false,
  items,
  onChange,
  placeholder,
  selectKey,
  size = "md",
  value,
}) => {
  const selectedItem = items.find((item) => item.value === value);

  return (
    <Select
      className={className}
      isDisabled={isDisabled}
      key={selectKey}
      onValueChange={onChange}
      selectedLabel={selectedItem?.label ?? placeholder}
      selectedValue={value ?? undefined}
    >
      <SelectTrigger
        className="border border-outline-200 rounded-xl bg-background-50"
        size={size}
        variant="outline"
      >
        <SelectInput
          className={
            selectedItem
              ? "text-typography-900 dark:text-typography-50"
              : "text-typography-400"
          }
          placeholder={placeholder}
        />
        <SelectIcon as={ChevronDownIcon} className="mr-3" />
      </SelectTrigger>
      <SelectPortal>
        <SelectBackdrop />
        <SelectContent className="rounded-t-3xl">
          <SelectDragIndicatorWrapper className="py-4">
            <SelectDragIndicator className="bg-outline-300 dark:bg-outline-600" />
          </SelectDragIndicatorWrapper>
          {items.map((item) => (
            <SelectItem
              isDisabled={item.isDisabled}
              key={`${item.value}-${item.label}`}
              label={item.label}
              value={item.value}
            />
          ))}
        </SelectContent>
      </SelectPortal>
    </Select>
  );
};

export { DropdownPicker };
export type { DropdownPickerItem, DropdownPickerProps };
